export class ProductInAllPharmacy {
    mId: number;
    mCreated: string;
    mModified: string;
    mStatus: string;
    mPharmacyId: number;
    mProductId: string;
    mPrice: number;
    mOriginalPrice: number;
    mPackageId: string;
    mEsModified: string;
    mProductName: string;
    mPkgName: string;
    mProductStatus: string;
    mLastUpdateBy: string;
    mInStock: boolean;
    mCategory: string;
    mPharmacyStatus: string;
    mAmountSold: number;
    mDiscountDescription: string;
    mDiscountId: number;
    mPharmacy: any;

    constructor(inventory: any) {
        this.mId = inventory?.mId || null;
        this.mCreated = inventory?.mCreated || '';
        this.mModified = inventory?.mModified || '';
        this.mStatus = inventory?.mStatus || '';
        this.mPharmacyId = inventory?.mPharmacyId || null;
        this.mProductId = inventory?.mProductId || '';
        this.mPrice = inventory?.mPrice || null;
        this.mOriginalPrice = inventory?.mOriginalPrice || null;
        this.mPackageId = inventory?.mPackageId || '';
        this.mEsModified = inventory?.mEsModified || '';
        this.mProductName = inventory?.mProductName || '';
        this.mPkgName = inventory?.mPkgName || '';
        this.mProductStatus = inventory?.mProductStatus || '';
        this.mLastUpdateBy = inventory?.mLastUpdateBy || '';
        this.mInStock = typeof inventory?.mInStock !== 'boolean' ? true : inventory?.mInStock;
        this.mCategory = inventory?.mCategory || '';
        this.mPharmacyStatus = inventory?.mPharmacyStatus || '';
        this.mAmountSold = inventory?.mAmountSold || null;
        this.mDiscountDescription = inventory?.mDiscountDescription || '';
        this.mDiscountId = inventory?.mDiscountId || null;
        this.mPharmacy = inventory?.mPharmacy || null;
    }
}

